import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class TaxCodeCfgQueryCriteriaClass extends BaseCriteriaModel {
  //bl_fi_cfg_tax_code table
  tax_country?: Optional<string> = Optional.empty();
  tax_gst_type?: Optional<string> = Optional.empty();
  tax_wht_type?: Optional<string> = Optional.empty();
  tax_code?: Optional<string> = Optional.empty();
  tax_code_descr?: Optional<string> = Optional.empty();
}

export class TaxCodeCfgCriteriaModelQuery {
  query = '';

  constructor(TaxCodeCfgCriteriaModel: TaxCodeCfgQueryCriteriaClass) {

    if (!TaxCodeCfgCriteriaModel) {
      return;
    }

    this.query += TaxCodeCfgCriteriaModel.tax_country.filter(x => x !== '').map(x => '&tax_country=' + x).orElse('');
    this.query += TaxCodeCfgCriteriaModel.tax_gst_type.filter(x => x !== '').map(x => '&tax_gst_type=' + x).orElse('');
    this.query += TaxCodeCfgCriteriaModel.tax_wht_type.filter(x => x !== '').map(x => '&tax_wht_type=' + x).orElse('');
    this.query += TaxCodeCfgCriteriaModel.tax_code.filter(x => x !== '').map(x => '&tax_code=' + x).orElse('');
    this.query += TaxCodeCfgCriteriaModel.tax_code_descr.filter(x => x !== '').map(x => '&tax_code_descr=' + x).orElse('');

    this.query += '&status=' + TaxCodeCfgCriteriaModel.status;
    this.query += '&orderBy=' + TaxCodeCfgCriteriaModel.orderBy;
    this.query += '&order=' + TaxCodeCfgCriteriaModel.order;
    this.query += '&offset=' + TaxCodeCfgCriteriaModel.offset + '&limit=' + TaxCodeCfgCriteriaModel.limit;
  }
}
